import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {

  override parse(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      // Handle dd.MM.yyyy format
      const parts = value.split('.');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
        const year = parseInt(parts[2], 10);
        
        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          const date = new Date(year, month, day);
          // Validate the date
          if (date.getFullYear() === year && 
              date.getMonth() === month && 
              date.getDate() === day) {
            return date;
          }
        }
      }
    }

    // Fallback to default parsing
    return super.parse(value);
  }

  override format(date: Date, displayFormat: Object): string {
    if (!date || !this.isValid(date)) {
      return '';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  override getDateNames(): string[] {
    const dateNames: string[] = [];
    for (let i = 1; i <= 31; i++) {
      dateNames.push(i.toString().padStart(2, '0'));
    }
    return dateNames;
  }
}
